import React from 'react';
export function BonusesSection() {
  const scrollToPurchase = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-20 px-4 bg-gradient-to-b from-brand-dark to-brand-card/80 border-t border-brand-gold/20" data-id="element-38">
      <div className="max-w-5xl mx-auto text-center" data-id="element-39">
        <h2 className="text-4xl md:text-5xl font-bold text-brand-gold mb-4 uppercase tracking-wider" data-id="element-40">
          🎁 Bonos Gratis Por Hoy
        </h2>
        <p className="text-xl text-white mb-12" data-id="element-41">
          Llévate el pack completo con todos estos recursos adicionales sin
          costo extra
        </p>

        <div className="relative mb-16" data-id="element-42">
          {/* Decorative background glow */}
          <div className="absolute inset-0 bg-brand-gold/10 blur-[100px] rounded-full" data-id="element-43"></div>

          <div className="relative z-10 p-4 md:p-8 glass-card rounded-3xl border border-brand-gold/30" data-id="element-44">
            <div className="absolute -top-4 -right-4 bg-brand-red text-white font-bold py-2 px-6 rounded-full transform rotate-12 shadow-lg border-2 border-white z-20" data-id="element-45">
              ¡GRATIS HOY!
            </div>

            <img src="https://cdn.magicpatterns.com/uploads/xad2vZLjGL86MmVCy8dS4A/italinao.png" alt="Megapack Completo con Bonos" className="w-full h-auto rounded-xl shadow-2xl mx-auto cursor-pointer hover:scale-[1.02] transition-transform duration-300" onClick={scrollToPurchase} data-id="element-46" />

            <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4 text-left" data-id="element-47">
              <div className="bg-brand-dark/80 p-4 rounded-xl border border-white/10" data-id="element-48">
                <span className="text-brand-gold font-bold block mb-1" data-id="element-49">
                  Bono 1
                </span>
                <p className="text-white text-sm" data-id="element-50">
                  Guía de pronunciación nativa
                </p>
              </div>
              <div className="bg-brand-dark/80 p-4 rounded-xl border border-white/10" data-id="element-51">
                <span className="text-brand-gold font-bold block mb-1" data-id="element-52">
                  Bono 2
                </span>
                <p className="text-white text-sm" data-id="element-53">
                  Plantillas de ejercicios prácticos
                </p>
              </div>
              <div className="bg-brand-dark/80 p-4 rounded-xl border border-white/10" data-id="element-54">
                <span className="text-brand-gold font-bold block mb-1" data-id="element-55">
                  Bono 3
                </span>
                <p className="text-white text-sm" data-id="element-56">
                  Diccionario visual de viaje
                </p>
              </div>
            </div>
          </div>
        </div>

        <button onClick={scrollToPurchase} className="w-full md:w-auto bg-brand-green hover:bg-green-600 text-white font-bold text-2xl py-5 px-10 rounded-xl shadow-[0_0_25px_rgba(0,146,70,0.5)] hover:shadow-[0_0_40px_rgba(0,146,70,0.7)] transition-all transform hover:scale-105 animate-pulse-slow" data-id="element-57">
          🔥 Quiero todo el pack completo ahora
        </button>
      </div>
    </section>;
}